// store/featureFlagSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { FeatureFlagData } from '../../types/featureFlag';
import { PURGE } from 'redux-persist';

const FEATURE_FLAG_URL = 'https://ledgerx365-featureflags.s3.ap-south-1.amazonaws.com/featureflag.json';

interface FeatureFlagState {
  flags: FeatureFlagData;
  loading: boolean;
  error: string | null;
}

const INITIAL_STATE: FeatureFlagState = {
  flags: {},
  loading: false,
  error: null,
};

export const fetchFeatureFlags = createAsyncThunk(
  'featureFlags/fetch',
  async (): Promise<FeatureFlagData> => {
    const response = await axios.get(FEATURE_FLAG_URL);
    return response.data;
  }
);

const featureFlagSlice = createSlice({
  name: 'featureFlags',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchFeatureFlags.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFeatureFlags.fulfilled, (state, action: PayloadAction<FeatureFlagData>) => {
        state.flags = action.payload;
        state.loading = false;
      })
      .addCase(fetchFeatureFlags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to load feature flags';
      })
       .addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});

export default featureFlagSlice.reducer;
